import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";

export const CartWrapper = styled.div`
  height: 100%;
  width: 100%;
  background-color: #fff;
  // max-width: 400px;
  // margin: 15px auto;

  height: 100%;
  width: 100%;
  background-color: #fff;
  margin: auto;
  padding-top: 15px;

  // @media screen and (min-width: 768px) {
  //   padding-right: 20px;
  // }
  @media screen and (max-width: 768px) {
    width: 80%;
    max-width: 400px;
  }
  @media screen and (min-width: 1600px) {
    width: 100%;
  }
  @media screen and (max-width: 425px) {
    width: 80%;
  }
`;

export const Cart = styled.div`
  // box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const CartTitle = styled.h1`
  width: 100%;
  padding: 10px 0;
  color: ${themeGet("colors.primary", "#9cc54b")};
  text-transform: Uppercase;
  text-align: center;
  font-size: 32px;
  background-color: #fff;
  font-weight: 800;

  @media screen and (min-width: 1600px) {
    font-size: 44px;
  }
   @media screen and (max-width: 1340px) {
    font-size: 25px !important;
  }
  @media screen and (max-width: 1250px) {
    font-size: 22px !important;
  }
  @media screen and (max-width: 990px) {
    font-size: 20px !important;
  }
  @media screen and (max-width: 760px) {
    font-size: 2rem !important;
  }

  @media screen and (max-width: 460px) {
    font-size: 1.4rem !important;
  }
  @media screen and (min-width: 2000px) {
    font-size: 50px;
  }
  @media screen and (min-width: 2300px) {
    font-size: 60px;
  }
`;

export const ProductImage = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  img {
    height: auto;
    width: auto;
    max-height: 300px;
    max-width: 300px;
    object-fit: cover;
    margin: auto;
    @media screen and (min-width: 2000px) {
      height: auto;
      width: auto;
      max-height: 400px;
      max-width: 400px;
    }
    @media screen and (max-width: 1250px) {
      height: auto;
      width: auto;
      max-height: 200px;
      max-width: 200px;
    }
    @media screen and (max-width: 990px) {
      height: auto;
      width: auto;
      max-height: 130px;
      max-width: 130px;
    }
    @media screen and (max-width: 767px) {
      height: auto;
      width: auto;
      max-height: 300px;
      max-width:  300px;
      padding: 20px 0;
    }
    @media screen and (max-width: 425px) {
      height: auto;
      width: auto;
      max-height: 200px;
      max-width:  200px;
    }
    @media screen and (min-width: 2300px) {
      max-height: 500px;
      max-width: 500px;
    }
  }
`;
export const CartFooterWrapper = styled.div `
 text-align: center;
  .product-country-and-btn {
    display: flex;
    justify-content: center;
  }
`
export const CartBodyWrapper = styled.div`
  width: 100%;
  text-align: center;
  font-size: 15px;
  padding-top: 15px;
  .product_name{
    font-weight: 600;


    @media screen and (min-width: 1440px) {
      font-size: 25px;
    }
    @media screen and (min-width: 1250px) {
      font-size: 23px;
    }
    @media screen and (min-width: 1024px) {
      font-size: 22px;
    }
    @media screen and (max-width: 767px) {
      font-size: 20px;
    }
    @media screen and (min-width: 2000px) {
      font-size: 30px;
    }
  }
  .product_price{
    color: #9cc54b;
    display: flex;
    width: 100%;
    justify-content: center;
    padding: 15px 0;
  }
  .p_price {
    color: #f49e02;
    font-size: 25px;
    font-weight: 800;
    margin: 0 5px;
    @media screen and (max-width: 1250px) {
      font-size: 20px;
    }
    @media screen and (max-width: 950px) {
      font-size: 15px;
    }

  }
  .dis_price {
    font-size: 25px;
    font-weight: 800;
    text-decoration : line-through;
    margin: 0 5px;
    @media screen and (max-width: 1250px) {
      font-size: 20px;
    }
    @media screen and (max-width: 950px) {
      font-size: 15px;
    }

  }

  @media screen and (min-width: 2000px) {
      font-size: 30px;
  }
  
`;
export const ProductStar = styled.div`
  width: 100%;
  padding: 5px;
  color: gold;
  @media screen and (max-width: 950px) {
      font-size: 12px !important;

    }
`;

export const ProductDescription = styled.p`
  text-align: center;
  color: gray;
  // height: 80px;
  font-size: 15px;
  padding: 5px 15px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* start showing ellipsis when 3rd line is reached */
  white-space: pre-wrap; 
  overflow: hidden;
  // @media screen and (min-width: 1600px) {
  //   height: 100px;
  //   // font-size: 20px;
  // }
  // @media screen and (max-width: 1200px) {
  //   // font-size: 14px;
  // }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    display: none;
  }
  @media screen and (min-width: 2000px) {
    font-size: 25px;
  }
`;

export const CartButton = styled.button`
  width: 60%;
  margin: auto;
  padding: 8px;
  font-size: 16px;
  font-weight: 700;
  background-color: ${themeGet("colors.primary", "#9cc54b")};
  color: #fff;
  border-radius: 10px;
  margin-top: 10px;
  border: none;

  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

  .cart-icon {
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    fill: #fff;
    margin-right: 5px;
  }
  .cart-icon svg {
    width: 100%;
    height: 100%;
  }

  @media screen and (min-width: 1600px) {
    font-size: 20px;
    padding: 12px;
  }
  @media screen and (max-width: 960px) {
    padding: 5px;
    font-size: 14px;
    // margin-top: 5px;
  }

   @media screen and (max-width: 760px) {
    padding: 7px;
    font-size: 18px;
    margin-top: 20px;
  }
   @media screen and (max-width: 460px) {
    padding: 5px;
    font-size: 15px;
  }
  @media screen and (min-width: 2300px) {
    font-size: 30px;
    .cart-icon {
      height: 30px;
      width: 30px;
    }
  }
`;

export const ProductPriceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 5px;
  flex-shrink: 0;
  // margin-left: 25px;
  line-height: 31px;

  @media (max-width: 767px) {
    // margin-left: 15px;
  }
`;
export const ProductPrice = styled.div`
  font-family: "Lato", sans-serif;
  font-size: 25px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: ${themeGet("colors.primary", "#9cc54b")};
  &.express { color: #f01266; }
  .promo-price {
    font-size: 24px !important;
    @media (max-width: 767px) {
      font-size: 19px !important;
    }
  }
  span.express { color: #f01266; }

  @media screen and (max-width: 1250px) {
    font-size: 20px;
  }
  @media screen and (max-width: 950px) {
    font-size: 15px;
  }
  @media screen and (min-width: 2000px) {
    font-size: 30px;
  }
`;
export const PromoPrice = styled.div`
  font-family: "Lato", sans-serif;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: ${themeGet("colors.yellow", "#FBB979")};
  // padding-left: 10px;

  font-size: 25px;

  @media screen and (max-width: 1250px) {
    font-size: 20px;
  }
  @media screen and (max-width: 950px) {
    font-size: 15px;
  }
  .promo-price {
      
    &.express{
      font-size: 1rem !important;
      line-height: 2rem;
      color: #FBB979 !important;
    }
    
    @media (max-width: 767px) {
      font-size: 19px !important;
    }
  }
  @media screen and (min-width: 2000px) {
      font-size: 35px;
    }
`;